import config, { BuildType } from '@/config';

export default (): boolean => {
  return config.buildType === BuildType.BROWSER_EXT;
};
